import { render, staticRenderFns } from "./TermsOfUse.vue?vue&type=template&id=856fcb06&scoped=true&"
var script = {}
import style0 from "./TermsOfUse.vue?vue&type=style&index=0&id=856fcb06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856fcb06",
  null
  
)

export default component.exports